<template>
  <div class="ui stackable grid segment acceptanceDate">

    <div class="five wide column acceptanceDate__container">
      <div class="acceptanceDateCalendar">
        <div class="acceptanceDateCalendar__nav">
          <a class="button prev-icon" @click="openDialog('prev')" :class="{'disabled': isLimitPrevYearMonth}"><i class="fas fa-chevron-left"></i><span>前月</span></a>
          <div><span>{{ month }}月</span>/{{ year }}</div>
          <a class="button next-icon" @click="openDialog('next')" :class="{'disabled': isLimitNextYearMonth}"><span>次月</span><i class="fas fa-chevron-right"></i></a>
        </div>
        <div class="acceptanceDateCalendar__dayOfTheWeek">
          <div v-for="(each, index) in dayOfTheWeek" :key="each" :class="{'blue': index % 7 === 5, 'red': index % 7 === 6}">{{ each }}</div>
        </div>
        <div class="acceptanceDateCalendar__days">
          <div class="acceptanceDateCalendar__days__day"
               v-for="(each, index) in days" :key="index" :class="{'blue': index % 7 === 5, 'red': index % 7 === 6, 'is-current-month': each.isCurrentMonth}">
            <svg v-if="each.isCurrentMonth && acceptanceDateStatus(each.day) === 1" class="circle-shape shape" :class="{'disabled': each.isCurrentMonth && isPastDate(generateDateFromDay(each.day))}" viewBox="0 0 20 20">
              <circle cx="10" cy="10" r="10"></circle>
              <foreignObject x="0" y="0" width="100%" height="100%">
                <div xmlns="http://www.w3.org/1999/xhtml"><span>{{ each.day }}</span></div>
              </foreignObject>
            </svg>
            <svg v-else-if="each.isCurrentMonth && acceptanceDateStatus(each.day) === 2" class="triangle-shape shape" :class="{'disabled': each.isCurrentMonth && isPastDate(generateDateFromDay(each.day))}" viewBox="0 0 20 20">
              <polygon points="10,0 20,20 0,20"></polygon>
              <foreignObject x="0" y="0" width="100%" height="100%">
                <div xmlns="http://www.w3.org/1999/xhtml"><span>{{ each.day }}</span></div>
              </foreignObject>
            </svg>
            <svg v-else-if="each.isCurrentMonth && acceptanceDateStatus(each.day) === 3" class="cross-shape shape" :class="{'disabled': each.isCurrentMonth && isPastDate(generateDateFromDay(each.day))}" viewBox="0 0 20 20">
              <line x1="3" y1="3" x2="17" y2="17" stroke-width="2"></line>
              <line x1="17" y1="3" x2="3" y2="17" stroke-width="2"></line>
              <foreignObject x="0" y="0" width="100%" height="100%">
                <div xmlns="http://www.w3.org/1999/xhtml"><span>{{ each.day }}</span></div>
              </foreignObject>
            </svg>
            <span v-else-if="!each.isCurrentMonth">{{ each.day }}</span>
          </div>
        </div>
      </div>
      <div class="acceptanceDateCalendarSupplement">
        <p>&#9675; … 空席あり</p>
        <p>&#9651; … 要相談</p>
        <p>&#215; … 空席無し</p>
      </div>
    </div>

    <div class="eleven wide column">
      <div class="acceptanceDateForm">
        <div class="acceptanceDateForm__header">
          <div><span>{{ month }}月</span>/{{ year }}</div>
        </div>
        <form class="ui form" @submit.prevent="save()" :class="{warning: form.hasErrors()}">
          <p>店舗の予約状況を入力してください。</p>

          <div class="ui stackable grid">
            <div class="five wide column" v-for="(dates, columnIndex) in splitAcceptanceDates" :key="`column_${columnIndex}`">
              <div class="acceptanceDateForm__contents" v-for="(acceptanceDate, index) in dates" :key="`date_${index}_column_${columnIndex}`">
                <div class="acceptanceDateForm__contents__label" :class="{ 'blue': isSaturday(acceptanceDate), 'red': isSunday(acceptanceDate) }" >{{ formatAcceptanceDates(acceptanceDate) }}</div>
                <div class="acceptanceDateForm__contents__radioGroup">
                  <label :for="`status1_${index}_column_${columnIndex}`" class="acceptanceDateForm__contents__radioGroup__label" :class="{'disabled': isPastDate(acceptanceDate.date)}">
                    <input type="radio" :id="`status1_${index}_column_${columnIndex}`" :value="1" :name="`status1_${index}_column_${columnIndex}`" v-model="acceptanceDate.status" hidden :disabled="isPastDate(acceptanceDate.date)" />
                    <span class="acceptanceDateForm__contents__radioGroup__label__mark green">
                      <svg viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="7" fill="transparent" stroke="white" stroke-width="2"/>
                      </svg>
                    </span>
                  </label>
                  <label :for="`status2_${index}_column_${columnIndex}`" class="acceptanceDateForm__contents__radioGroup__label" :class="{'disabled': isPastDate(acceptanceDate.date)}">
                    <input type="radio" :id="`status2_${index}_column_${columnIndex}`" :value="2" :name="`status2_${index}_column_${columnIndex}`" v-model="acceptanceDate.status" hidden :disabled="isPastDate(acceptanceDate.date)" />
                    <span class="acceptanceDateForm__contents__radioGroup__label__mark yellow">
                      <svg viewBox="0 0 24 24" fill="none">
                        <polygon points="12,6 18,18 6,18" fill="transparent" stroke="white" stroke-width="2"/>
                      </svg>
                    </span>
                  </label>
                  <label :for="`status3_${index}_column_${columnIndex}`" class="acceptanceDateForm__contents__radioGroup__label" :class="{'disabled': isPastDate(acceptanceDate.date)}">
                    <input type="radio" :id="`status3_${index}_column_${columnIndex}`" :value="3" :name="`status3_${index}_column_${columnIndex}`" v-model="acceptanceDate.status" hidden :disabled="isPastDate(acceptanceDate.date)" />
                    <span class="acceptanceDateForm__contents__radioGroup__label__mark red">
                      <svg viewBox="0 0 24 24" fill="none">
                        <line x1="6" y1="6" x2="18" y2="18" stroke="white" stroke-width="2"/>
                        <line x1="6" y1="18" x2="18" y2="6" stroke="white" stroke-width="2"/>
                      </svg>
                    </span>
                  </label>
                </div>
                <validation-message :form="form" field="acceptance_dates"></validation-message>
              </div>
              <div v-if="columnIndex === 2" class="saveButton" :class="{'exists': dates.length !== 0}">
                <button type="submit" class="ui positive button" :disabled="isPastDate()">保存</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div id="show-moved-dialog" class="ui tiny modal">
      <div class="content">
        <p class="text">保存されていない内容があります！</p>
        <p class="text">このページを離れますか？</p>
      </div>
      <div class="actions">
        <button class="ui button cancel" @click="closeDialog()">戻る</button>
        <button class="ui button move" @click="onMove()">離れる</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            dayOfTheWeek: ['月', '火', '水', '木', '金', '土', '日'],
            days: [],
            year: moment().year(),
            month: moment().month() + 1,
            currentYear: moment().year(),
            currentMonth: moment().month() + 1,
            limitPrevYearMonth: null,
            limitNextYearMonth: null,
            moveType: '',
            isSaved: false,

            form: this.createForm({
                acceptance_dates: [],
            }),
        }
    },
    created: function() {
        this.limitPrevYearMonth = moment().subtract(11, 'months').date(1);
        this.limitNextYearMonth = moment().add(11, 'months').date(1);
        this.days = this.generateCalendar(this.year, this.month);

        this.fetchAcceptanceDate(this.year, this.month);
    },
    methods: {
        generateCalendar: function(year, month) {
            let days = [];

            // 前月
            const firstDay = moment([year, month - 1]).startOf('month').day();
            const daysFromPrevMonth = firstDay === 0 ? 6 : firstDay - 1;
            for (let i = daysFromPrevMonth; i > 0; i--) {
                days.push({
                    'day': moment([year, month - 1]).startOf('month').subtract(i, 'days').date(),
                    'isCurrentMonth': false,
                });
            }

            // 今月
            const daysInMonth = moment([year, month - 1]).daysInMonth();
            for (let i = 1; i <= daysInMonth; i++) {
                days.push({
                    'day': i,
                    'isCurrentMonth': true,
                });
            }

            // 次月
            let nextMonthDayCount = 1;
            while (days.length % 7 !== 0) {
                days.push({
                    'day': moment([year, month - 1]).endOf('month').add(nextMonthDayCount, 'days').date(),
                    'isCurrentMonth': false,
                });
                nextMonthDayCount++;
            }
            return days;
        },
        generateDateFromDay: function(day) {
            return moment({ year: this.year, month: this.month - 1, day: day });
        },
        onPrevMonth: function() {
            if (this.isLimitPrevYearMonth) {
                return;
            }
            if (this.month === 1) {
                this.month = 12;
                this.year--;
            } else {
                this.month--;
            }
            this.days = this.generateCalendar(this.year, this.month);
            this.fetchAcceptanceDate(this.year, this.month);
            this.isSaved = false;
        },
        onNextMonth: function() {
            if (this.isLimitNextYearMonth) {
                return;
            }
            if (this.month === 12) {
                this.month = 1;
                this.year++;
            } else {
                this.month++;
            }
            this.days = this.generateCalendar(this.year, this.month);
            this.fetchAcceptanceDate(this.year, this.month);
            this.isSaved = false;
        },
        fetchAcceptanceDate: function(year, month) {
            this.form.model.acceptance_dates = [];
            this.form.get(`/shopadmin/api/acceptance_dates/${year}/${month}`, function(response) {
                if (response.data.length === 0) {
                    const currentMonthDays = this.days.filter(function(day) {
                        return day.isCurrentMonth;
                    });
                    for (let i = 0; i < currentMonthDays.length; i++) {
                        const date = moment({ year: this.year, month: this.month - 1, day: currentMonthDays[i].day });
                        const formattedDate = date.format('YYYY-MM-DD');
                        this.form.model.acceptance_dates.push({
                            date: formattedDate,
                            status: 1,
                        });
                    }
                } else {
                    this.form.model.acceptance_dates = response.data;
                }
            }.bind(this));
        },
        formatAcceptanceDates: function(acceptanceDate) {
            const date = moment(acceptanceDate.date);
            const dayOfTheWeek = date.day() === 0 ? 6 : date.day() - 1;
            return `${date.date()}(${this.dayOfTheWeek[dayOfTheWeek]})`;
        },
        isSaturday: function(acceptanceDate) {
            const date = moment(acceptanceDate.date);
            return date.day() === 6;
        },
        isSunday: function(acceptanceDate) {
            const date = moment(acceptanceDate.date);
            return date.day() === 0;
        },
        isPastDate: function(date) {
            if (date) {
                const now = moment().startOf('day');
                const inputDate = moment(date).startOf('day');
                return inputDate.isBefore(now);
            } else {
                const inputMoment = moment({ year: this.year, month: this.month - 1 });
                return inputMoment.isBefore(moment(), 'month');
            }
        },
        acceptanceDateStatus: function(day) {
            const formattedDay = day.toString().padStart(2, '0');
            const acceptanceDate = this.form.model.acceptance_dates.find(function(acceptanceDate) {
                return moment(acceptanceDate.date).format('DD') === formattedDay;
            });
            return acceptanceDate ? acceptanceDate.status : 1;
        },
        openDialog: function(moveType) {
            if (this.isSaved || this.isPastDate()) {
                if (moveType === 'prev') {
                    this.onPrevMonth();
                } else if (moveType === 'next') {
                    this.onNextMonth();
                }
            }
            else {
                $('#show-moved-dialog').modal({autofocus: false}).modal('show');
            }
            this.moveType = moveType;
        },
        closeDialog: function() {
            $('#show-moved-dialog').modal('hide');
        },
        onMove: function() {
            $('#show-moved-dialog').modal('hide');
            if (this.moveType === 'prev') {
                this.onPrevMonth();
            } else if (this.moveType === 'next') {
                this.onNextMonth();
            }
        },
        save: function() {
            this.form.post('/shopadmin/api/acceptance_dates', function() {
                alert('保存しました。');
                this.isSaved = true;
            });
        },
    },
    computed: {
        isLimitPrevYearMonth: function() {
            const currentMoment = moment({ year: this.year, month: this.month - 1 });
            const limitPrevYearMonthMoment = moment(this.limitPrevYearMonth);
            return currentMoment.isSame(limitPrevYearMonthMoment, 'month');
        },
        isLimitNextYearMonth: function() {
            const currentMoment = moment({ year: this.year, month: this.month - 1 });
            const limitNextYearMonthMoment = moment(this.limitNextYearMonth);
            return currentMoment.isSame(limitNextYearMonthMoment, 'month');
        },
        splitAcceptanceDates: function() {
            const chunkSize = 14;
            const maxColumnSize = 3;
            const acceptance_dates = this.form.model.acceptance_dates;
            let columns = [];

            for (let i = 0; i < maxColumnSize; i++) {
                const startIndex = i * chunkSize;
                const endIndex = startIndex + chunkSize;
                columns.push(acceptance_dates.slice(startIndex, endIndex));
            }

            return columns;
        },
    },
}
</script>

